<span class="form-input-dropdown">
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+field) | translate" [hidden]="noLabel" class="input-label"></label>
  <p-dropdown #dropdown [ngModel]="formControl['value']" class="p-inputtext-sm" [options]="options"
    optionLabel="{{optionsField || 'name'}}" inputId="{{id}}" (onChange)="onSelectChange($event)" [filter]="filter"
    filterBy="{{optionsField || 'name'}}" [showClear]="clearable && !!formControl['value']" [appendTo]="appendTo ? appendTo : ''"
    [disabled]="formControl['disabled']" [ngClass]="{ 'disabled': formControl['disabled'] }"
    [ngStyle]="{ 'background-color': field === 'color' && formControl['value']?.id }" [placeholder]="placeholder || ''" 
    [virtualScroll]="options.length > 20" [itemSize]="30" scrollHeight="200px">
    <!-- each option -->
    <ng-template let-option pTemplate="item">
      <div class="custom-option" 
        [ngClass]="{ 'color-option': field === 'color' }"
        [ngStyle]="{ 'background-color': field === 'color' && option?.id }"
        [pTooltip]="showTooltip && option[optionsField || 'name']"
        tooltipEvent="hover" tooltipPosition="top" [escape]="false"
        [innerHTML]="option[optionsField || 'name']">
      </div>
    </ng-template>
    <!-- selected option -->
    <ng-template let-selectedOption pTemplate="selectedItem">
      <div class="custom-option-selected"
        [pTooltip]="showTooltip && selectedOption && [selectedOption[optionsField || 'name']]"
        tooltipEvent="hover" tooltipPosition="top" 
        [innerHTML]="selectedOption && [selectedOption[optionsField || 'name']]">
      </div>
    </ng-template>
  </p-dropdown>
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"></app-form-input-error>
</span>
